import Icon from '../components/Icon.vue'

Icon.register({
  'sad-tear': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM328 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM152 416c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0-13.1 17.4-41.6 57.8-41.6 77.8 0 26 21.5 47 48 47zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM338.2 394.2c13.3 16.1 38.3-4 24.5-20.4-28.4-34.2-70.3-53.8-114.7-53.8-21.2 0-21.2 32 0 32 34.9 0 67.8 15.4 90.2 42.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sad-tear.js
// module id = 1859
// module chunks = 0